<template>
  <div class="buttons-wrapper">
    <template v-if="registerLink && isExternal">
      <a
          v-if="!isFollowed"
          class="text-decoration-none"
          style="width: 100%"
          :href="registerLink"
          @click="toggleDwhExternalRegisterLink"
          target="_self"
          rel="noopener noreferrer"
      >
        <button type="button" class="buttons-wrapper__btn buttons-wrapper__btn--register">
          Register
        </button>
      </a>
      <button
          v-else
          type="button"
          class="buttons-wrapper__btn buttons-wrapper__btn--registered buttons-wrapper__btn--external"
      >
        Registered
      </button>
    </template>
    <template v-if="registerLink && !isExternal">
      <button
          v-if="!isFollowed"
          type="button"
          class="buttons-wrapper__btn buttons-wrapper__btn--register"
          @click="$emit('follow')"
      >
        Register
      </button>
      <button
          v-else
          type="button"
          class="buttons-wrapper__btn buttons-wrapper__btn--registered"
          @click="$emit('follow')"
      >
        Registered
      </button>
    </template>
    <button
        v-if="isFollowed && !registerLink"
        type="button"
        class="buttons-wrapper__btn buttons-wrapper__btn--registered buttons-wrapper__btn--disabled"
        disabled
    >
      Registered
    </button>
    <button
        v-if="isNotEventDetails && !registerLink && !isFollowed"
        @click="goToEvent"
        type="button"
        class="buttons-wrapper__btn buttons-wrapper__btn--registered"
    >
      See Details
    </button>
    <div
        v-if="isNotEventDetails"
        @click="$emit('addToBookmark')"
        class="buttons-wrapper__bookmark"
    >
      <Icon
          color="var(--button-icon-tint)"
          :type="bookmarked ? 'bookmark' : 'bookmark_empty'"
          :size="24"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: 'EventRegisterButton',
  props: {
    isExternal: Boolean,
    isFollowed: Boolean,
    registerLink: String,
    eventId: Number,
    bookmarked: Boolean,
  },
  computed: {
    isNotEventDetails() {
      return this.$route.name !== 'event-by-id'
    },
  },
  methods: {
    toggleDwhExternalRegisterLink() {
      if (this.$route.name === 'events') {
        this.$emit('handleExternalRegisterEvent')
      } else {
        this.$emit('handleExternalRegisterEventDetails')
      }
    },
    goToEvent() {
      this.$router.push({ name: 'event-by-id', params: { id: this.eventId } })
      this.$emit('handleSeeDetailEvent')
    },
  },
}
</script>
<style lang="scss">
.buttons-wrapper {
  padding: 12px;
  display: flex;
  gap: 8px;
  width: 100%;

  &__btn {
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    height: 46px;
    border-radius: 8px;
    font-family: 'Inter', sans-serif;
    font-weight: 700;
    font-size: 18px;
    line-height: 100%;
    text-align: center;
    cursor: pointer;

    &--register {
      border: 1.5px solid #9b9b9b;
      color: var(--button-main-color);
      background-color: var(--button-main-background-color) !important;
    }

    &--registered {
      border: 1.5px solid var(--button-secondary-background-color);
      background-color: #ffffff;
      color: var(--button-secondary-background-color);
    }

    &--external {
      border-color: #9b9b9b;
      color: #9b9b9b;
    }

    &--disabled {
      border-color: #9b9b9b;
      color: #9b9b9b;
      cursor: not-allowed;
      opacity: 0.7;
    }
  }

  &__bookmark {
    width: 46px;
    height: 46px;
    border-radius: 8px;
    background-color: #f3f3f6;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
}

</style>

